import React from "react";
import PropTypes from "prop-types";
import localize from "helpers/localize";
import restHelper from "helpers/aee/restHelper";
import withLock from "./withLock";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Grid,
  Paper
} from "@material-ui/core";

const LC = "cloud";

class AeeInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      loading: false
    };
  }

  componentDidMount() {
    /*const { setToolbarItems } = this.props;
    setToolbarItems(<div>LOL</div>);*/
    this.view();
  }

  view = () => {
    const { cashregister_id: ap, client_id: client } = this.props;
    this.setState({ loading: true });
    restHelper
      .view("cashregister-aee-info/view", null, { ap, client })
      .then(response => {
        this.setState({ item: response.data, loading: false });
      });
  };
  render() {
    const { item, loading } = this.state;
    return (
      <Grid container spacing={16}>
        {/*<Grid item xs={12}>
          <Typography variant="h6">AEE Teszt</Typography>
    </Grid>*/}
        <Grid item xs={12} md={8} lg={6}>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{localize(LC, "Funkció")}</TableCell>
                  <TableCell>{localize(LC, "Eredmény")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(item || {}).map(key => {
                  return (
                    <TableRow key={key} style={{ height: "unset" }}>
                      <TableCell>{item[key].label}</TableCell>
                      <TableCell>
                        {item[key].value === "OK" ? (
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            {item[key].vale}
                          </span>
                        ) : (
                          item[key].value
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

AeeInfo.propTypes = {
  cashregister_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  client_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired
};

export default withLock(AeeInfo, "AEE_INFO", {
  dataTitle: "Eszköz info",
  title: "Eszköz info",
  forceUpdate: false,
  hideEditButton: true
});



// WEBPACK FOOTER //
// ./src/Containers/Pages/Cloud/AeeInfo.js